var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "j_header" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "ul",
      {
        staticStyle: {
          float: "right",
          "list-style-type": "none",
          padding: "0px",
          margin: "0px"
        }
      },
      [
        _c("li", [
          _c(
            "div",
            {
              staticClass: "function_div",
              staticStyle: { cursor: "pointer" },
              attrs: { id: "login_out" },
              on: { click: _vm.loginout }
            },
            [_vm._m(1)]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          position: "absolute",
          top: "0",
          left: "0",
          height: "40px"
        }
      },
      [
        _c("img", {
          staticStyle: {
            height: "30px",
            position: "relative",
            left: "21px",
            top: "9px"
          },
          attrs: { src: require("../assets/icon/logo.png") }
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticStyle: { "font-size": "20px", "margin-left": "40px" } },
          [_vm._v("安龙脉德 一 办公OA系统")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        staticClass: "f_image",
        attrs: { src: require("../assets/icon/tuichu.png") }
      }),
      _vm._v("\n        退出\n        ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-796c7d80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-796c7d80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header_info.vue
// module id = null
// module chunks = 